import Colors from "../Colors";

const baseArmor = {
  glyph: {
    fg: Colors.B_GREY_4,
    ch: "&",
  },
};

export const armors = {
  frock: {
    ...baseArmor,
    text: {
      name: "An Unadorned Frock",
      info: "A light robe, provides minimal poise",
      description:
        "These unassuming frocks are worn the world over. The monks of the floating abbey first popularized their use.",
      logName: "Frock",
    },
    wearable: "armor",
    stats: {
      weight: 2,
      armor: 0,
      poise: 20,
    },
  },
  tunic: {
    ...baseArmor,
    text: {
      name: "A Threadbare Tunic",
      info: "Light and easy to wear",
      description: "A well worn garment made of cloth and linen.",
      logName: "Tunic",
    },
    wearable: "armor",
    stats: {
      weight: 6,
      armor: 5,
      poise: 20,
    },
  },
  bCoat: {
    ...baseArmor,
    text: {
      name: "Buff Coat",
      logName: "Coat",
      info: "Solid protection from attacks without much weight.",
      description:
        "The war for which this was made is long forgotten. Features an emblem of a divine horse over trampled men.",
    },
    wearable: "armor",
    stats: {
      weight: 8,
      armor: 8,
      poise: 40,
    },
  },
  gambeson: {
    ...baseArmor,
    text: {
      name: "Gambeson",
      logName: "Gambeson",
      info: "Strong protection without inhibiting movement",
      description:
        "Deemed contraband by the church, this armor has been passed down through generations.",
    },
    wearable: "armor",
    stats: {
      weight: 10,
      armor: 15,
      poise: 60,
    },
  },
  curiass: {
    ...baseArmor,
    text: {
      name: "Linen Curiass",
      logName: "Cuirass",
      info: "Its heft offers good protection.",
      description:
        "Strongly woven linen, but still breathable. A rare relic of the Long Wars.",
    },
    wearable: "armor",
    stats: {
      weight: 15,
      armor: 20,
      poise: 80,
    },
  },
  bouilli: {
    ...baseArmor,
    text: {
      name: "Cuir bouilli",
      logName: "Cuir bouilli",
      info: "Heavy and bulky, but can stop even a dedicated blow.",
      description:
        "Layers of glue and boiled leather hastily assembled into an armor. Worn often by those wishing to challenge the church's armaments",
    },
    wearable: "armor",
    stats: {
      weight: 30,
      armor: 40,
      poise: 120,
    },
  },
};
